// Cena aktuálně zvolené varianty. U produktů s variantami obsahuje .price-final
// jeden .price-final-holder pro každou kombinaci (neaktivní mají .noDisplay)
// a navíc výchozí "od X Kč" (.default-variant), který platí, dokud není varianta zvolená.
function getCurrentPriceHolder() {
  const $holders = $(".p-final-price-wrapper .price-final").first().find(".price-final-holder");
  let $holder = $holders.filter(":not(.noDisplay):not(.default-variant)").first();

  if (!$holder.length) {
    $holder = $holders.filter(".default-variant").first();
  }
  if (!$holder.length) {
    $holder = $holders.length ? $holders.first() : $(".p-final-price-wrapper .price-final").first();
  }

  return $holder;
}

// true = varianta není zvolená a varianty mají různé ceny ("od X Kč")
function isProductPriceFrom() {
  const $holder = getCurrentPriceHolder();
  return $holder.hasClass("default-variant") && /^\s*od\b/i.test($holder.text());
}

function getCurrentProductPrice() {
  return parseFloat(
    getCurrentPriceHolder()
      .text()
      .replace(/\s/g, "")
      .replace(/[^\d,.-]/g, "")
      .replace(",", "."),
  );
}

function navratnostCalculator() {
  const $calculator = $(".p-info-wrapper .calculator");
  const workingDaysPerYear = 250;

  if ($calculator.length) {
    let productPrice = getCurrentProductPrice();

    const $calculatorPrice = $calculator.find(".price .tls .number").first();
    const $inputs = $calculator.find(".hour input, .clients input");
    const $result = $calculator.find(".result .number").first();
    let $resultUnit = $result.parent().find(".calculator-result-unit").first();

    if (!$resultUnit.length) {
      $resultUnit = $('<span class="calculator-result-unit"></span>').appendTo($result.parent());
    }

    function renderProductPrice() {
      if (!Number.isNaN(productPrice)) {
        $calculatorPrice.text((isProductPriceFrom() ? "od " : "") + productPrice.toLocaleString("cs-CZ"));
      }
    }

    renderProductPrice();

    function parseCalculatorInput(value) {
      return parseFloat(String(value).replace(/\s/g, "").replace(",", "."));
    }

    let $variantNote = $result.parent().find(".calculator-variant-note").first();
    if (!$variantNote.length) {
      $variantNote = $('<span class="calculator-variant-note">Nejdříve vyberte variantu produktu</span>').appendTo($result.parent()).hide();
    }

    function calculateReturn() {
      // U "od X Kč" nevíme přesnou cenu, takže návratnost nepočítáme a vyzveme k výběru varianty
      const needsVariant = isProductPriceFrom();
      $calculator.toggleClass("needVariant", needsVariant);
      $variantNote.toggle(needsVariant);
      $result.add($resultUnit).toggle(!needsVariant);
      if (needsVariant) return;

      const massagePrice = parseCalculatorInput($inputs.eq(0).val());
      const clientsPerDay = parseCalculatorInput($inputs.eq(1).val());
      const returnInDays = (productPrice / (massagePrice * clientsPerDay * workingDaysPerYear)) * workingDaysPerYear;
      let resultValue = 0;
      let resultUnit = "dní";

      if (Number.isFinite(returnInDays) && returnInDays > 0) {
        if (returnInDays >= 365) {
          resultValue = Math.ceil(returnInDays / 365);
          resultUnit = resultValue === 1 ? "rok" : resultValue < 5 ? "roky" : "let";
        } else if (returnInDays >= 30) {
          resultValue = Math.ceil(returnInDays / 30);
          resultUnit = resultValue === 1 ? "měsíc" : resultValue < 5 ? "měsíce" : "měsíců";
        } else {
          resultValue = Math.ceil(returnInDays);
          resultUnit = resultValue === 1 ? "den" : resultValue < 5 ? "dny" : "dní";
        }
      }

      $result.text(resultValue);
      $resultUnit.text(resultUnit);
    }

    // Po změně varianty Shoptet přepne .noDisplay až po vyvolání eventu, proto čteme cenu se zpožděním
    function refreshProductPrice() {
      setTimeout(function () {
        const newPrice = getCurrentProductPrice();
        if (Number.isNaN(newPrice)) return;
        productPrice = newPrice;
        renderProductPrice();
        calculateReturn();
      }, 50);
    }

    $inputs.on("input", calculateReturn);
    calculateReturn();

    if (!navratnostCalculator.variantListenersBound) {
      navratnostCalculator.variantListenersBound = true;
      ["ShoptetVariantAvailable", "ShoptetVariantUnavailable", "ShoptetSurchargesPriceUpdated", "ShoptetSplitVariantParameterChange"].forEach(function (eventName) {
        document.addEventListener(eventName, function () {
          navratnostCalculator.refreshPrice && navratnostCalculator.refreshPrice();
        });
      });
      $(document).on("change.navratnost", ".p-info-wrapper select.parameter-id, .p-info-wrapper .hidden-split-parameter, .p-info-wrapper #simple-variants-select", function () {
        navratnostCalculator.refreshPrice && navratnostCalculator.refreshPrice();
      });
    }
    navratnostCalculator.refreshPrice = refreshProductPrice;
  }
}
